import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onMount", "onUnmount"];
import React from 'react';
/** ХОК, который не вызовет ремаунты (как withMountListener) если ссылка на onMount меняется  */
export function withOnMountHandler(WrappedComponent) {
  var Component = function Component(_ref) {
    var onMount = _ref.onMount,
      onUnmount = _ref.onUnmount,
      props = _objectWithoutProperties(_ref, _excluded);
    React.useEffect(function () {
      onMount === null || onMount === void 0 || onMount();
      return function () {
        return onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
      };
    }, []);
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      "data-t-id": "utils-withOnMountHandler"
    }));
  };
  return Component;
}